import {setupAccountTitles} from "./account";
import {setupAdTakeover} from "./ad-takeover";
import {setupAdHeroTakeover} from "./ad-hero-takeover";
import {setupAM100Table} from "./am100";
import {setupLikeArticle} from "./article-like";
import {setupASEMetricPage} from "./ase-metric-page";
import {setupASELandingPage} from "./ase-landing-page";
import {setupBDOGraphPage} from "./bdo-graph-page";
import {setupBDOLandingPage} from "./bdo-landing-page";
import { setupCarLaunchCalendar } from "./car-launch-calendar";
import {setupCarReviewSearch} from "./car-review-search";
import {setupCarReviewSection} from "./car-review-section";
import {setupCarsLandingPage} from "./cars-landing-page";
import {setupCommenting} from "./commenting";
import {setupCountdowns} from "./countdown";
import {setupDealerManagement} from "./dealer-management";
import { setupFaqSearch } from "./faq";
import {setupGallery} from "./gallery";
import {setupGoogleAnalytics} from "./google-analytics";
import {setupAMJobSearch} from "./jobs";
import {setupManufacturerInsightDataResults} from "./manufacturer-insight";
import {setupManufacturerInsightsDatatable} from "./manufacturer-insight-datatable";
import {setupRetailNewCarFinanceManufacturer} from "./retail-new-car-finance";
import {setupShareThis} from "./sharethis";
import {setupSupplierZone} from "./supplier-zone";
import {setupUsedCarSalesFigures} from "./used-car-sales-figure";
import {ajaxSetup} from "./ajax-config";
import {
    setupOneLinkAverageCostOfServiceCar, setupOneLinkAverageLabourRate,
    setupOneLinkAveragePriceOfWindscreenWiper,
    setupOneLinkPercentageOfAllSMRJobsInFranchise,
    setupOneLinkAveragePriceOfClutch,
    setupOneLinkAveragePriceOfFrontDisc
} from "./epyx-data";

ajaxSetup();
function needsGoogleCharts() {
    const pageType = $("#PageType").val();
    const chartPages = ['OneLinkAveragePriceOfWindscreenWiper','OneLinkAveragePriceOfClutch', 'OneLinkAveragePriceOfFrontDisc', 'OneLinkPercentageOfAllSMRJobsInFranchise', 'OneLinkAverageCostOfService', 'OneLinkAverageCostOfCarParts'];
    return chartPages.includes(pageType);
}
$(() => {
    setupAccountTitles();
    setupAdTakeover();
    setupAdHeroTakeover();
    setupAM100Table();
    setupLikeArticle();
    setupASEMetricPage();
    setupASELandingPage();
    setupBDOGraphPage();
    setupBDOLandingPage();
    setupCarLaunchCalendar();
    setupCarReviewSearch();
    setupCarReviewSection();
    setupCarsLandingPage();
    setupCommenting();
    setupCountdowns();
    setupDealerManagement();
    setupFaqSearch();
    setupGallery();
    setupGoogleAnalytics();
    setupAMJobSearch();
    setupManufacturerInsightDataResults();
    setupManufacturerInsightsDatatable();
    setupRetailNewCarFinanceManufacturer();
    setupShareThis();
    setupSupplierZone();
    setupUsedCarSalesFigures();
    if (needsGoogleCharts()) {
        const pageType = $("#PageType").val(); // Get the value of hidden field
        if (pageType === 'OneLinkAveragePriceOfWindscreenWiper') {
            setupOneLinkAveragePriceOfWindscreenWiper();
        } else if (pageType === 'OneLinkAveragePriceOfClutch') {
            setupOneLinkAveragePriceOfClutch();
        } else if (pageType === 'OneLinkAveragePriceOfFrontDisc') {
            setupOneLinkAveragePriceOfFrontDisc();
        } else if (pageType === 'OneLinkPercentageOfAllSMRJobsInFranchise') {
            setupOneLinkPercentageOfAllSMRJobsInFranchise();
        } else if (pageType === 'OneLinkAverageCostOfService') {
            setupOneLinkAverageCostOfServiceCar();
            //setupOneLinkAverageCostOfService();
        } else if (pageType === 'OneLinkAverageLabourRate') {
            setupOneLinkAverageLabourRate();
        } else if (pageType === 'OneLinkAverageCostOfCarParts') {
            setupOneLinkAverageCostOfCarParts();
        }
    }
    const qrCodeDataElement = document.getElementById("qrCodeData");
    if (qrCodeDataElement) {
        const uri = qrCodeDataElement.getAttribute('data-url');
        new QRCode(document.getElementById("qrCode"), {
            text: uri,
            width: 150,
            height: 150
        });
    }
})